const TZ_SUFFIX_RE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Backend timestamps (reading time_utc, transient event_time, alarm
 * alarm_time, ...) are UTC instants but arrive in mixed serializations:
 * epoch-ms numbers, ISO strings with a designator, or timezone-naive datetime
 * strings. `new Date(naive)` / `Date.parse(naive)` interpret naive datetimes
 * as browser-local and silently shift the instant by the viewer's UTC offset
 * (WEB-1218) — parse naive strings as UTC instead.
 */
export const toEpochMs = (raw) => {
  if (typeof raw === 'number') return raw;
  if (raw instanceof Date) return raw.getTime();
  if (typeof raw !== 'string' || !raw) return NaN;
  const s = raw.trim();
  if (TZ_SUFFIX_RE.test(s)) return Date.parse(s);
  const t = s.replace(' ', 'T');
  return Date.parse(t.includes('T') ? `${t}Z` : t);
};
